/* @flow */
import liferay from 'services/liferay';
import type { AsyncAction } from 'types/index';

const onFailure = (error: Object) => console.warn(error);

const login = (email: string, password: string): AsyncAction => {
  return {
    type: 'LOGIN_REQUEST',
    promise: liferay.login(email, password),
    meta: { onFailure },
  };
};

const logout = (): AsyncAction => {
  return {
    type: 'LOGOUT_REQUEST',
    promise: liferay.logout(),
    meta: { onFailure },
  };
};

export default {
  login,
  logout,
};
